import { HoneygainLogoSdk } from '@hg/stylizator/illustrations'
import { Optional } from '@hg/stylizator/utils'
import * as React from 'react'
import withSizes from 'react-sizes'

import Header from 'app/components/Header'
import { MOBILE_HEADER_MIN_WIDTH } from 'app/components/Header/model'
import { useGlobalState } from 'app/store'

interface IProps {
  isMobileHeader?: boolean
}

const HoneygainSdkTopMenu: React.FC<IProps> = (props) => {
  const [opened, setOpened] = React.useState<Optional<boolean>>()
  const [scrolled, setScrolled] = React.useState(false)
  const [menuItems] = useGlobalState('sdkMenu')

  if (!props.isMobileHeader) {
    if (opened) {
      setOpened(false)
    }
    document.body.style.overflow = ''
  }

  React.useEffect(() => {
    const handleScroll = (): void => {
      setScrolled(window.scrollY > 64)
    }

    window.addEventListener('scroll', handleScroll)

    return (): void => {
      window.removeEventListener('scroll', handleScroll)
    }
  }, [])

  return (
    <Header
      languages={[]}
      scrolled={scrolled}
      opened={opened}
      items={menuItems ?? []}
      logo={<HoneygainLogoSdk width={195} />}
      logoUrl="/honeygain-sdk"
      onMenuToggle={() => {
        setOpened((val) => !val)
        document.body.style.overflow = !opened ? 'hidden' : ''
      }}
    />
  )
}

const mapSizesToProps = (props: any) => ({
  isMobileHeader: props.width <= MOBILE_HEADER_MIN_WIDTH,
})

export default withSizes<IProps, IProps>(mapSizesToProps)(HoneygainSdkTopMenu)
